<template>
  <div class="dialog-form">
    <el-form v-if="load" ref="form" :model="data" label-width="auto" @submit.native.prevent>
      <form-list
        v-for="(item, fIndex) in form"
        :key="fIndex"
        :data="data"
        :row="item.row || { gutter: 20 }"
        :options="item.group"
      />
    </el-form>
  </div>
</template>

<script>
import FormList from '@utils/form/components/add-page-list.js'
export default {
  components: {
    FormList
  },
  props: {
    // eslint-disable-next-line
    $form: {
      type: Object,
      default: () => ({})
    },
    row: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: -1
    },
    getData: {
      type: Function,
      default: async() => ({})
    }
  },
  data() {
    return {
      data: {},
      load: false
    }
  },
  computed: {
    form() {
      return Object.freeze(this.$form.form) || []
    }
  },
  async created() {
    this.load = false
    this.data = this.$form.getData ? this.$form.getData() : {}
    const data = await this.getData(this.row)
    Object.assign(this.data, this.row, data)
    this.load = true
  }
}
</script>

<style lang="scss" scoped>
.dialog-form {
  padding: 10px 10px 0 10px;
}
</style>
